<template>
  <div style="overflow-x:hidden">
    <v-form ref="formbuilder">
      <v-card tile flat class="mt-4 pa-1">
        <v-card-text class="mt-4 pt-2 ">
          <v-row v-if="loadingFields" class="fill-height" align-content="center" justify="center">
            <v-col class="subtitle-1 text-center" cols="12">
              <span> {{ $t('message.props.preparingFields') }} </span>
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-text-field outlined hide-details :rules="$_requiredValidation" :label="$t('message.props.name')" v-model="formProp.name" required dense></v-text-field>
            </v-col>
            <!-- <v-col cols="3">
              <v-autocomplete :items="listOfModules" v-model="formProp.module" item-text="name" item-value="id" hide-details outlined :label="$t('selectModule')"
                dense :rules="$_requiredValidation">
              </v-autocomplete>
            </v-col> -->
            <v-col cols="3">
              <v-autocomplete :items="listChecklistOfStatus" v-model="formProp.status" item-text="name" item-value="id" hide-details outlined :label="$t('message.props.selectStatus')" dense :rules="$_requiredValidation">
              </v-autocomplete>
            </v-col>
            <v-col cols="3" v-if="formProp.id">
              {{ formProp.file }}
              <v-file-input outlined dense hide-details :label="$t('message.props.template')" v-model="formTemplateFile" accept="application/pdf"></v-file-input>
              <v-sheet class="ml-8 py-4" v-if="formProp.pdftemplatepath">
                <v-card small outlined>
                  <v-layout row wrap class="mx-1 my-0">
                    <v-icon class="mx-1" size="18" color="error">mdi-file-pdf</v-icon>
                    <p class="pa-0 ma-0 my-auto mr-3 text-truncate" style="max-width:85%">{{ formProp.templateoriginalname || formProp.pdftemplatepath }}</p>
                    <v-spacer></v-spacer>
                    <v-btn icon class="my-auto" color="info" @click="downloadTemplate(formProp.id)" width="22" height="22">
                      <v-scale-transition>
                        <v-icon color="success" size="18">mdi-download</v-icon>
                      </v-scale-transition>
                    </v-btn>
                  </v-layout>
                </v-card>
              </v-sheet>
            </v-col>
          </v-row>
          <v-divider  class="ma-2 mt-7" v-if="!formProp.id"></v-divider>
          <v-col cols="3" v-if="formProp.id">
            <v-btn tile color="primary" style="color:white" @click="getPDFContent('head')">{{ $t('message.form.addHeader') }}</v-btn>
              &nbsp;
            <v-btn tile color="primary" style="color:white" @click="getPDFContent('foot')">{{ $t('message.form.addFooter') }}</v-btn>
          </v-col>
          <template v-if="pageLoader && formProp.id">
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </template>
          <template v-else>
            <v-form ref="fieldsForm">
              <v-row v-if="formProp.id">
                <v-col cols="12" class="mt-1 pb-0 mt-1 ml-2">
                  <v-divider class="ma-2"></v-divider>
                  <v-row class="ma-0">
                    <v-btn fab x-small color="primary" @click="addNewProperty()"><v-icon>mdi-plus</v-icon></v-btn>
                    <span class="ml-2 mt-1"><h3>{{ $t('message.form.formProps') }}</h3></span>
                  </v-row>
                </v-col>
                <v-col cols="3" lg="3" xl="2">
                  <div id="component-section" class="fixed-cloumn" :class="componentSectionFixed ? 'component-section-fixed' : ''" :style="componentSectionFixed ? `width: ${componentFixedWidth}px;` : ''" ref="expansionPanelGroup">
                    <v-card outlined class="pt-4 mt-1 px-2" height="700">
                      <v-card-title class="pa-0"><small class="ml-2" v-html="`* <code>${$t('message.props.drag')}</code> ${$t('message.props.properties')}`"></small></v-card-title>
                      <v-divider class="ma-2"></v-divider>
                      <v-card-text class="pa-0">
                        <v-row class="ma-1">
                          <v-col :cols="[19, 15 ,10, 14].includes(item.type) ? 12 : 6" class="pa-1" v-for="(item, index) in listOfFormTypes" :key="index">
                            <v-btn small tile width="100%" :ripple="false"  height="30" color="primary"  outlined draggable @dragstart="startDrag($event, item)"
                              large @dragend="removeHighlighter(false, 'remove')" class="hover--class">
                              <v-icon size="22" color="primary"> {{ item.icon }} </v-icon>
                              <v-spacer></v-spacer>
                              <span class="text-truncate mx-1" :title="item.name" style="max-width:200px;color:black;">{{ item.name }} </span>
                              <v-spacer></v-spacer>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="9" xl="10" lg="9">
                  <div class="parent-div">
                    <div :class="`${dragging ? 'drop-highlight' : ''}`"
                      @drop="onDrop($event)" @dragover.prevent @dragenter.prevent class="apply-height-width ">
                      <v-row v-if="listOfAddedFields && listOfAddedFields.length" id='fieldDroppingArea' class="ma-2">
                        <draggable v-model="listOfAddedFields" class="row mx-1" id="fieldDroppingArea">
                          <template v-for="(item, index) in listOfAddedFields">
                            <v-col class="pa-1"  v-if="!item.isPanelField" :cols="item.columns && ![15, 10, 19, 14].includes(item.type) ? item.columns : '12'"
                              :md="item.columns && ![15, 10, 19].includes(item.type) ? item.columns: [10, 11, 12, 15, 19].includes(item.type) ? '12' : '6'" :key="index">
                              <form-fields :ref="`parentSignature_${item.id}`" :fields="fields" :item="item" :edit="editProperties" :addToPanel="addItemsToPanel" :remove="removeFormField"
                                :fieldDragging="fieldDragging" @isPanelInPanel="(booleanVal) => isPanelInPanel = booleanVal" :reOrdering = fieldReorder>
                              </form-fields>
                            </v-col>
                          </template>
                        </draggable>
                      </v-row>
                      <template v-else>
                        <v-alert prominent text type="info" class="text-center mb-0 alert-height">
                          <span class="text-center ml-4 font-weight-bold text-subtitle-1">{{ $t('message.form.dropFields') }}</span>
                        </v-alert>
                      </template>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </template>
        </v-card-text>
      </v-card>
    </v-form>
     <v-dialog v-model="dialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <v-card>
        <v-card-title class="pa-2 ma-0" style="background: #000000;color: white">
          <h5 :style="$vuetify.theme.dark ? 'color: #dacdcd' : ''">{{ properties._id ? $t('message.props.updateProps') : $t('message.props.addProps') }}</h5>
          <v-spacer></v-spacer>
          <v-btn icon title="Close" :color="$vuetify.theme.dark ? '#dacdcd' : 'white'" @click="closeDialogHandler()">
           <v-icon>mdi-close-circle</v-icon>
          </v-btn>
       </v-card-title>
       <v-card-text class="pa-1">
        <form-properties :payload="payload" :propertyNames="existingPropNames()" :propertyGroupedByType="groupedByType" v-if="dialog" :properties="properties" @closeForm="closePropertyDialog"
          @change="setValue">
        </form-properties>
       </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="pdfTemplateDialog" persistent width="700">
      <v-card>
      <v-card-title>{{ $t('message.form.addHtmlContent') }} {{ pdfContent.type === 'head' ? $t('message.form.forHeader') : $t('message.form.forFooter') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-2">
        <v-form ref="pdfContentForm">
          <v-textarea dense rows="20" filled :rules="$_requiredValidation" v-model="pdfContent.data"></v-textarea>
        </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="success" class="mr-3" tile :loading="pdfContentLoading" @click="savePDFContent">{{ $t('message.common.update') }}</v-btn>
            <v-btn color="error" tile @click="pdfTemplateDialog = false, $refs.pdfContentForm.reset()">{{ $t('message.common.close') }}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import checklist from '@/mixins/Checklist/checklist'
import { mapGetters, mapState } from 'vuex'
import { standardFields, advancedFields } from '../../utils/checklistutils/support_list'
import { checklistApi } from '@/plugins/checklist_api'
export default {
  mixins: [checklist],
  props: {
    token: {
      type: String,
      default: () => ''
    },
    formProp: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      properties: {},
      fields: {},
      loading: false,
      propertiesLoading: false,
      loadingFields: false,
      listOfAddedFields: [],
      dialog: false,
      pdfTemplateDialog: false,
      pdfContent: {
        data: '',
        type: ''
      },
      pdfContentLoading: false,
      activePanel: {},
      listOfGroups: [],
      groupsLoading: false,
      dragging: false,
      newFieldColumns: 0,
      expandedPanel: 0,
      groupedByType: [],
      customProperties: [],
      fieldDragging: false,
      isPanelInPanel: false,
      componentSectionFixed: false,
      componentFixedWidth: 0,
      payload: {},
      fromUpdate: false,
      allFields: [],
      reOrdering: false,
      fieldReorder: false,
      listOfFormTypes: [...standardFields, ...advancedFields],
      tab: 0,
      favourite: [],
      pageLoader: true,
      height: window.innerHeight - 78,
      formTemplateFile: []
    }
  },
  components: {
    draggable: () => import('vuedraggable'),
    'form-properties': () => import('@/components/Checklist/property/Index.vue'),
    'form-fields': () => import('@/components/Checklist/FormFields')
  },
  computed: {
    ...mapState(['userDetails']),
    ...mapGetters(['listOfModules'])
  },
  created () {
    this.getAllGroups()
  },
  mounted () {
    if (this.formProp.id) {
      this.getSingleRecordHandler()
    }
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'forms') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteSuccess') })
        this.$store.commit('hideDialog')
        this.getSingleRecordHandler()
      }
    })
    this.$root.$on('closeDialog', () => {
      this.dialog = false
    })
    this.$root.$on('updateProperty', (data) => {
      this.fromUpdate = true
      const fieldsList = this.$formatter.cloneVariable(this.listOfAddedFields)
      if (data.update) {
        const index = fieldsList.findIndex(x => x._id === data.model.id)
        fieldsList[index] = data.model
      } else {
        data.model.id = undefined
        data.model.tab_order = this.listOfAddedFields.length
        fieldsList.push(data.model)
      }
      this.updateFormProperty(data.model)
      // this.updateFormProperties(this.formProp.form_id, fieldsList)
      // this.getSingleRecordHandler()
      this.dialog = false
      this.pageLoader = true
    })
    this.$root.$on('clonePanelEvent', data => {
      this.cloneAllTheFields(data)
    })
    this.$root.$on('isPanelHighlighted', (booleanValue) => {
      this.removeHighlighter(!booleanValue, 'hide')
    })
    this.$root.$on('setFieldColumn', (data) => {
      this.newFieldColumns = data
    })
    this.$root.$on('saveUpdate', (type) => {
      this.saveUpdateHandler(type)
    })
    this.$eventBus.$on('handleScrolling', data => {
      this.handleScroll(data)
    })
  },
  methods: {
    // drag start
    startDrag (event, item) {
      this.fieldDragging = true
      this.dragging = true
      var fieldDropPanel = document.getElementById('fieldDroppingArea')
      if (fieldDropPanel) {
        var children = Array.from(fieldDropPanel.children)
        var allFields = []
        children.forEach(child => {
          console.log(child.classList)
          if (child.classList && child.classList.length) {
            const getClassArray = child.classList.toString().split(' ')
            const getColClass = getClassArray.find(x => x.startsWith('col-'))
            let getCol = 12
            if (getColClass) {
              getCol = parseInt(getColClass.split('-')[2])
            }
            allFields.push({ element: child, columns: isNaN(getCol) ? 6 : getCol })
          }
        })
        const rowReferenceObj = { previousRows: 0, currentRowOccupiedColumns: 0 }
        allFields.forEach((field, index) => {
          rowReferenceObj.currentRowOccupiedColumns += field.columns
          let tempColumns = rowReferenceObj.currentRowOccupiedColumns
          if ((index + 1) !== allFields.length) tempColumns += allFields[index + 1].columns
          if (tempColumns > 12) {
            rowReferenceObj.previousRows += 1
            rowReferenceObj.currentRowOccupiedColumns = 0
          }
        })
        let newElementColumn = 12 - rowReferenceObj.currentRowOccupiedColumns
        newElementColumn = newElementColumn === 0 ? 12 : newElementColumn
        var div = document.createElement('div')
        div.setAttribute('class', `col-md-${newElementColumn}`)
        div.setAttribute('style', 'border: 3px dashed #1fb2aa;')
        fieldDropPanel.appendChild(div)
        this.newFieldColumns = newElementColumn
        event.dataTransfer.dropEffect = 'move'
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('item', JSON.stringify(item))
        window.localStorage.setItem('DragData', JSON.stringify(item))
        event.stopPropagation()
      }
    },
    // Drop
    onDrop (event) {
      if (event.dataTransfer.getData('item')) {
        const item = JSON.parse(event.dataTransfer.getData('item'))
        if (item) this.addNewFieldToForm(item)
      }
      this.fieldDragging = false
      event.preventDefault()
      event.stopPropagation()
    },
    // removing highlighter
    removeHighlighter (drag, removeOrHide) {
      this.dragging = drag
      var fieldDropPanel = document.getElementById('fieldDroppingArea')
      if (fieldDropPanel) {
        var children = Array.from(fieldDropPanel.children)
        const lastChild = children[children.length - 1]
        if (removeOrHide === 'remove') {
          fieldDropPanel.removeChild(lastChild)
          this.fieldDragging = false
        } else {
          lastChild.style.display = drag ? 'block' : 'none'
        }
      }
      let canvas = document.getElementsByTagName('canvas')
      if (canvas.length) {
        canvas = Array.from(canvas)
        canvas.forEach((x) => {
          x.remove()
        })
      }
      this.$root.$emit('isFieldDragging', false)
    },
    // the following logic added for re-ordering elements in dom
    // fieldsReorderHandler (target) {
    //   let childrens = target && target.children ? target.children : []
    //   let currentElement = null
    //   if (childrens.length) {
    //     for (let i of childrens) {
    //       i.draggable = true
    //       i.addEventListener('dragstart', () => {
    //         // storing dragging element
    //         currentElement = i
    //         // this.fieldDragging = true
    //         this.fieldReorder = true
    //       })
    //       i.addEventListener('dragover', (evt) => {
    //         evt.preventDefault()
    //         evt.stopPropagation()
    //       })
    //       i.addEventListener('drop', (evt) => {
    //         evt.preventDefault()
    //         evt.stopPropagation()
    //         let draggingIndex = 0
    //         let droppedIndex = 0
    //         for (let j = 0; j < childrens.length; j++) {
    //           if (currentElement === childrens[j]) {
    //             draggingIndex = j
    //           }
    //           if (i === childrens[j]) {
    //             droppedIndex = j
    //           }
    //         }
    //         console.log(draggingIndex)
    //         console.log(droppedIndex)
    //         setTimeout(() => {
    //           this.reOrderArray(draggingIndex, droppedIndex)
    //           if (draggingIndex < droppedIndex && currentElement) {
    //             i.parentNode.insertBefore(currentElement, i.nextSibling)
    //           } else if (currentElement) {
    //             i.parentNode.insertBefore(currentElement, i)
    //           }
    //         }, 200)
    //         if (evt.dataTransfer.getData('item')) {
    //           const item = JSON.parse(event.dataTransfer.getData('item'))
    //           console.log(item)
    //           if (item) this.addNewFieldToForm(item)
    //         }
    //       })
    //     }
    //   }
    // },
    // re-ordering the array
    reOrderArray (draggedIndex, droppedIndex) {
      this.reOrdering = true
      this.allFields = this.$formatter.cloneVariable(this.listOfAddedFields)
      const temp = this.allFields[draggedIndex]
      this.allFields[draggedIndex] = this.allFields[droppedIndex]
      this.allFields[droppedIndex] = temp
    },
    setValue (model) {
      model.panelid = this.properties.panelid
      this.properties = model
    },
    saveUpdateHandler (type) {
      if (this.$refs.formbuilder.validate()) {
        this.loading = true
        const fieldsList = this.reOrdering ? this.$formatter.cloneVariable(this.allFields) : this.$formatter.cloneVariable(this.listOfAddedFields)
        const model = this.$formatter.cloneVariable(this.formProp)
        const formObj = { name: model.name, module: 'common' }
        checklistApi[model.id ? 'put' : 'post'](model.id ? `forms/${model.form_id}` : 'forms', formObj, this.token).then(response => {
          model.form_id = response.data._id
          if (!model.id) model.id = 0
          this.$_saveUpdateHandler('checklisttemplates', model).then((savedObj) => {
            if (this.formTemplateFile && this.formTemplateFile.name) {
              var formData = new FormData()
              formData.append(this.formTemplateFile.name, this.formTemplateFile)
              this.$_executeApi('post', `checklisttemplates/upload_pdf_template/${savedObj.id}`, formData).then(() => {
                this.showSuccessMsg(response, type, model)
              })
            } else {
              this.showSuccessMsg(response, type, model)
            }
            if (model.id) this.updateFormProperties(model.form_id, fieldsList)
          })
        }).catch((error) => {
          this.$emit('update', { data: error, status: 'error', type })
        }).finally(() => {
          this.loading = false
        })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'validationFailed' })
    },
    // updating form properties
    updateFormProperties (id, fieldsList) {
      for (let i = 0; i < fieldsList.length; i++) {
        fieldsList[i].form_id = id
        if ([6, 7].includes(fieldsList[i].type) && fieldsList[i].default_value.default_Value_keyword) {
          fieldsList[i].default_value.default_value = ''
        }
        fieldsList[i].default_value = fieldsList[i].default_value ? JSON.stringify(fieldsList[i].default_value) : null
        fieldsList[i].validation = fieldsList[i].validation ? fieldsList[i].validation : null
      }
      const itemsJSON = { items: this.$formatter.cloneVariable(fieldsList) }
      checklistApi.post(`formproperties/bulk_save/${id}`, itemsJSON).then(() => {
      }).finally(() => {
        this.loading = false
      })
      if (this.activePanel._id) this.activePanel = {}
    },
    getSingleRecordHandler () {
      checklistApi.get(`forms/${this.formProp.form_id}`, this.token).finally(() => {
        this.getAllPropertiesHandler()
      })
    },
    // getting all form properties for a specific form
    getFormProperties () {
      checklistApi.get(`formproperties/get_by_form/${this.formProp.form_id}`, this.token).then(result => {
        if (result && result.data) {
          const listOfProperties = result.data
          for (let i = 0; i < listOfProperties.length; i++) {
            listOfProperties[i].default_value = listOfProperties[i].default_value ? JSON.parse(listOfProperties[i].default_value) : null
            listOfProperties[i].validation = listOfProperties[i].validation ? listOfProperties[i].validation : null
            const getPanelFieldIndex = listOfProperties.findIndex(x => x._id === listOfProperties[i].default_value.panelId)
            if (getPanelFieldIndex >= 0) {
              if (!listOfProperties[getPanelFieldIndex].panel_fields) listOfProperties[getPanelFieldIndex].panel_fields = []
              listOfProperties[getPanelFieldIndex].panel_fields.push(listOfProperties[i])
            }
            if (listOfProperties[i].default_value && listOfProperties[i].default_value.panelId) listOfProperties[i].isPanelField = true
          }
          this.listOfAddedFields = listOfProperties
          // setTimeout(() => {
          //   this.fieldsReorderHandler(document.getElementById('fieldDroppingArea'))
          // }, 200)
        }
      }).finally(() => {
        this.pageLoader = false
      })
    },
    // getting all properties
    getAllPropertiesHandler () {
      this.propertiesLoading = true
      const query = [{ $match: { Is_Active: true } }]
      checklistApi.post('properties/query', query).then((response) => {
        if (response && response.data) {
          // this.favourite = response.data.filter(x => x.favourite)
          this.customProperties = response.data
        }
      }).finally(() => {
        this.getFormProperties()
        this.propertiesLoading = false
      })
    },
    addItemsToPanel (item) {
      this.activePanel = item
    },
    addNewFieldToForm (item) {
      if (item && !this.isPanelInPanel) {
        const payload = this.$formatter.cloneVariable(item)
        if (payload._id) payload.prop_id = payload._id
        const propid = payload.prop_id
        const newFieldName = this.generateUniqueFieldName(item.name)
        this.openCreateDialog(newFieldName, propid, item)
      }
    },
    generateUniqueFieldName (fieldName, list = null) {
      const numbers = []
      let name = ''
      const addedFields = list || this.listOfAddedFields
      fieldName = fieldName.split(/(\d+)/)[0] || fieldName
      const value = addedFields.filter(x => x.name.toString().includes(fieldName))
      if (value.length > 0) {
        value.map((val) => {
          if (val && val.name.split(/^[^0-9]+/)[1]) {
            numbers.push(val.name.split(/^[^0-9]+/)[1])
          }
          return val
        })
        const getMax = numbers.length > 0 ? Math.max(...numbers) : 0
        const newFieldId = getMax + 1
        fieldName = fieldName.replace(/[0-9]/g, '')
        name = `${fieldName}${newFieldId}`
      } else {
        name = fieldName
      }
      return name
    },
    cloneAllTheFields (data) {
      if (data) {
        const cloneFields = []
        // eslint-disable-next-line camelcase
        const { modified_at, form_id, tab_order, name, label, type, validation, default_value, placeholder, is_active, panel_fields, columns } = data
        const panelField = { name: this.generateUniqueFieldName(name), modified_at, form_id, tab_order, label, type, validation, default_value: JSON.stringify(default_value), placeholder, is_active, columns }
        checklistApi.post('formproperties', panelField).then((response) => {
          if (response && response.data) {
            panelField._id = response.data._id
            panelField.default_value = panelField.default_value ? JSON.parse(panelField.default_value) : null
            cloneFields.push(panelField)
            const panelFields = this.$formatter.cloneVariable(panel_fields)
            if (panelFields && panelFields.length) {
              panelFields.forEach((field) => {
                /* send this list for checking from existing fields */
                const fieldsList = [...this.$formatter.cloneVariable(this.listOfAddedFields), ...this.$formatter.cloneVariable(cloneFields)]
                field.name = this.generateUniqueFieldName(field.name, fieldsList)
                field._id = null
                field.default_value = Object.assign({ ...field.default_value }, { panelId: panelField._id })
                cloneFields.push(field)
              })
              const mergeWithExistsFields = [...this.listOfAddedFields, ...cloneFields]
              this.updateFormProperties(form_id, mergeWithExistsFields)
            }
            this.getSingleRecordHandler()
          }
        })
      }
    },
    updateFormProperty (model) {
      const method = model._id ? 'put' : 'post'
      const url = model._id ? `formproperties/${model._id}` : 'formproperties'
      model.form_id = this.formProp.form_id
      if (typeof model.default_value !== 'string') model.default_value = JSON.stringify(model.default_value)
      checklistApi[method](url, model).then(({ data }) => {
        if (method === 'post') {
          this.listOfAddedFields.push(model)
        } else {
          const index = this.listOfAddedFields.findIndex(x => x._id === model._id)
          this.listOfAddedFields[index] = model
        }
        this.getSingleRecordHandler()
      })
    },
    removeFormField (item) {
      if (item) {
        let ids = [item._id]
        if (item.panel_fields) {
          const panelIds = item.panel_fields.map(x => x._id)
          ids = [...ids, ...panelIds]
        }
        this.$store.commit('showDeleteDialog', {
          url: '/formproperties/delete_multiple',
          module: 'forms',
          fromCheckList: true,
          ids
        })
      }
    },
    openCreateDialog (name, propid, property) {
      const panelid = this.activePanel._id || 0
      if (this.activePanel._id) this.activePanel = {}
      this.payload = { from: 'forms', savedAlready: false, propid, panelid, name: property ? name : null, setColumns: this.newFieldColumns }
      if (property && property.type === 18) this.payload.setColumns = 12
      if (property && property.type === 15) this.payload.setColumns = ''
      if (property && (property.isStandard || property.isAdvanced)) {
        this.payload.type = property.type
        this.payload.isStandard = property.isStandard
        this.payload.isAdvanced = property.isAdvanced
      }
      this.properties = this.payload
      this.newFieldColumns = 0
      this.groupedByType = this.customProperties
      this.dialog = true
    },
    editProperties (item) {
      this.groupedByType = []
      this.dialog = true
      this.payload = { from: 'forms', savedAlready: true, propid: item._id, name: item.name }
      this.properties = this.payload
    },
    getValuesFromAPI (serachRef, value, index) {
      this.$_executeApi('get', value.apiUrl, { headers: '' }).then(response => {
        if (value.objectName) this.listOfAddedFields[index].default_value.options = response.data[value.objectName]
        else this.listOfAddedFields[index].default_value.options = response.data
      })
    },
    closePropertyDialog () {
      this.dialog = false
    },
    getPDFContent (type) {
      this.pdfContent.type = type
      checklistApi.get(`forms/${this.formProp.form_id}`).then(response => {
        if (response.data) {
          this.pdfTemplateDialog = true
          const prop = this.pdfContent.type === 'head' ? 'pdf_header' : 'pdf_footer'
          if (response.data[prop]) this.pdfContent.data = response.data[prop]
        }
      })
    },
    savePDFContent () {
      if (this.$refs.pdfContentForm.validate()) {
        this.pdfContentLoading = true
        const prop = this.pdfContent.type === 'head' ? 'pdf_header' : 'pdf_footer'
        const model = { [prop]: this.pdfContent.data }
        checklistApi.put(`forms/${this.formProp.form_id}`, model).then(response => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'updateSuccess' })
          this.$refs.pdfContentForm.reset()
        }).finally(() => {
          this.pdfTemplateDialog = false
          this.pdfContentLoading = false
        })
      }
    },
    getAllGroups () {
      checklistApi.get('groups').then((response) => {
        this.listOfGroups = response.data
      })
    },
    existingPropNames () {
      let items = this.$formatter.cloneVariable(this.listOfAddedFields)
      if (this.properties._id) {
        items = items.filter(x => x._id !== this.properties._id)
      }
      const fieldsNames = items.map(x => x.name)
      return fieldsNames
    },
    addNewProperty () {
      this.dialog = true
      this.payload = { isnewProperty: true, from: 'forms', savedAlready: false, type: 1 }
      this.properties = this.payload
    },
    closeDialogHandler () {
      // this.$refs.formbuilder.reset()
      this.dialog = false
    },
    downloadTemplate (id) {
      this.$_executeApi('get', `checklisttemplates/download_pdf_template/${id}`).then((response) => {
        window.open(`${process.env.VUE_APP_URL}file/download?fileName=${response.data}`, '_blank')
      })
    },
    showSuccessMsg (response, type, model) {
      this.$emit('update', { data: response, status: 'success', type, action: model.id ? 'update' : 'add' })
    },
    handleScroll (scrollY) {
      var window_top = scrollY
      var componentSection = document.getElementById('component-section')
      if (componentSection) {
        var div_top = componentSection.offsetTop * 2
        this.componentFixedWidth = componentSection.clientWidth
        if (window_top > div_top) {
          this.componentSectionFixed = true
        } else {
          this.componentSectionFixed = false
        }
      }
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$root.$off('updatePropertyList')
    this.$root.$off('closeDialog')
    this.$root.$off('updateProperty')
    this.$root.$off('clonePanelEvent')
    this.$eventBus.$off('isPanelHighlighted')
    this.$root.$off('saveUpdate')
    this.$eventBus.$off('handleScrolling')
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style>
.hover--class {
    cursor: move;
  }
.drop-highlight {
    transition: background-color 0.5s ease;
    background-color: #D3D3D3;
    border: 1px dashed #8198af;
  }
  .content_wrap_custom > .v-expansion-panel-content__wrap {
    padding: 0px 2px 2px 2px !important;
  }
  /** Drag and Drop styles */
.parent-div {
    border: 2px dashed #1976d26b;
    margin-top:10px;
    margin-right:10px;
    padding:10px;
    height:100%;
  }
.apply-height-width {
  height:inherit !important;
  width:100% !important;
}
.alert-height {
  height:inherit !important;
}
.panel-header {
  min-height:34px !important;
  font-size: 14px
}
.child-elements {
  pointer-events: none !important;
}
.apply-scroll::-webkit-scrollbar {
  display: none;
}
.custom-scroll {
  overflow-y: hidden !important;
}
.component-section-fixed {
  position: fixed;
  top: 70px;
}
.fields-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
